import Yup from "../validation/yup";
import { PHONE_REGEX } from "../validation/regex";
const VERSION = 1;
export class ContactFormModel {
    constructor() {
        this.VERSION = VERSION;
        this.prefferedLocale = 'en';
        this.gender = '';
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.phone = '';
        this.message = '';
    }
    static get validationSchema() {
        return Yup.object({
            // gender: Yup.string().required(),
            firstName: Yup.string().max(255).trim().required(),
            lastName: Yup.string().max(255).trim().required(),
            email: Yup.string().lowercase().email().required(),
            phone: Yup.string().notRequired().matches(PHONE_REGEX),
            message: Yup.string().max(1000).trim().required(),
        });
    }
}
export default {
    ContactFormModel
};
